import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SubmitFilesetRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SubmitFilesetResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const submitFileset = (request: SubmitFilesetRequest, options?: CashRequestOptions) =>
  post<SubmitFilesetRequest, SubmitFilesetResponse>('/2.0/cash/submit-fileset', request, {
    ...options,
    rejectOnError: true,
  })
